// Generated by purs version 0.15.15
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var castableRecordRLNil = {};
var castableRecordRLConsOptional = function () {
    return function () {
        return {};
    };
};
var castableRecordRLConsDirect = function () {
    return {};
};
var castableRecordRLConsCastable = function () {
    return function () {
        return {};
    };
};
var castableRecord = function () {
    return function () {
        return function () {
            return {};
        };
    };
};
var castableIntNumber = {};
var castableForeign = {};
var castableCharString = {};
var cast = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
export {
    cast,
    castableIntNumber,
    castableCharString,
    castableRecord,
    castableForeign,
    castableRecordRLNil,
    castableRecordRLConsDirect,
    castableRecordRLConsCastable,
    castableRecordRLConsOptional
};
//# sourceMappingURL=index.js.map
